import { CpgReport } from '@features/campaigns';
import { TOTAL_DIMENSIONS } from '@features/executive-report';
import { DimensionSlug, validDimensionSlug } from '@features/reports/domain';
import { sortNullable } from '@utils/arrays';

const selectedDimensionSlugs = new Set<DimensionSlug>([
  'aud',
  'creative',
  'channel',
]);

export type Subdimension = CpgReport['dimensions'][number];

export type SubdimensionsByName = Partial<
  Record<DimensionSlug, Subdimension[]>
>;

export const subdimensionsByName = (subdimensions: Subdimension[]) =>
  subdimensions.reduce((acc, subdimension) => {
    const dimensionSlug = subdimension.dimensionName;
    if (!validDimensionSlug(dimensionSlug)) return acc;

    acc[dimensionSlug] = [...(acc[dimensionSlug] ?? []), subdimension];
    return acc;
  }, {} as SubdimensionsByName);

export const sortBySalesLift = (a: Subdimension, b: Subdimension) => {
  return sortNullable(
    a.incrementalSalesLift ?? null,
    b.incrementalSalesLift ?? null
  );
};

export const topDimensionsByNameSorted =
  (subdimensionsByName: SubdimensionsByName) =>
  (sortFunction: (a: Subdimension, b: Subdimension) => number) =>
    Object.entries(subdimensionsByName).reduce(
      (acc, [dimensionSlug, subdimensions]) => {
        if (!validDimensionSlug(dimensionSlug)) return acc;

        if (!selectedDimensionSlugs.has(dimensionSlug)) return acc;

        acc[dimensionSlug] = subdimensions
          .toSorted(sortFunction)
          .slice(0, TOTAL_DIMENSIONS);
        return acc;
      },
      {} as SubdimensionsByName
    );
